import { Button } from '@/components/ui/button';

interface FinalCTAProps {
  onGoogleLogin: () => void;
  isUnavailable?: boolean;
}

export function FinalCTA({ onGoogleLogin, isUnavailable }: FinalCTAProps) {
  return (
    <section className="py-20 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Meet Someone New?
        </h2>
        <p className="text-gray-400 mb-8">
          Join thousands of people connecting from around the world
        </p>

        <div className="flex flex-col items-center gap-4">
          <Button
            onClick={onGoogleLogin}
            disabled={isUnavailable}
            className="h-14 px-10 text-lg font-semibold bg-[#11B981] hover:bg-[#0EA874] text-white disabled:bg-gray-600 disabled:cursor-not-allowed"
          >
            Get Started Free
          </Button>
          {isUnavailable ? (
            <p className="text-amber-400 text-sm">
              Service temporarily unavailable. Please try again later.
            </p>
          ) : (
            <p className="text-gray-500 text-sm">
              Free forever. No credit card required.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
